module.exports = __webpack_public_path__ + "static/img_1670-9937bf0574ce8afd4fac00bddf423795.webp";